import * as React from 'react';
import { RenderElementProps } from 'slate-react';

import { Box } from '../../../Common/BoxV2';
import { ConnectedBookReview } from './components/BookReview';
import { ConnectedCenterReview } from './components/CenterReview';
import { ConnectedCourseReview } from './components/CourseReview';
import { ConnectedTeacherReview } from './components/TeacherReview';
import { ReviewType } from './types';

export const UserSpecialObjectElement = ({ attributes, children, element }: RenderElementProps) => {
  const { reviewType, id } = element as unknown as { id: string; reviewType: ReviewType };
  const anchor = element.anchor as string;

  const renderReview = React.useCallback(() => {
    switch (reviewType) {
      case 'book':
        return <ConnectedBookReview id={id} />;
      case 'teacher':
        return <ConnectedTeacherReview id={id} anchor={anchor} metaRight={null} />;
      case 'course':
        return <ConnectedCourseReview id={id} anchor={anchor} metaRight={null} />;
      case 'center':
        return <ConnectedCenterReview id={id} anchor={anchor} metaRight={null} />;
      default:
        return undefined;
    }
  }, [anchor, id, reviewType]);

  return (
    <Box {...attributes} className="font-inter" contentEditable={false} position="relative">
      {renderReview()}
      {children}
    </Box>
  );
};
